const isVector = (value, size) =>
  Array.isArray(value) && value.length === size && value.every(item => typeof item === 'number' && Number.isFinite(item))

export function parseReadyBlueprint(raw, catalog) {
  const issues = []
  if (!raw || raw.schemaVersion !== 1) issues.push('blueprint.schemaVersion must equal 1')
  if (raw?.catalogId !== catalog.catalogId) issues.push('blueprint.catalogId must match catalog.catalogId')
  if (typeof raw?.blueprintId !== 'string' || !raw.blueprintId) issues.push('blueprintId is required')
  if (
    !isVector(raw?.footprint?.sizeM, 2) ||
    raw.footprint.sizeM.some(value => value <= 0) ||
    !Number.isFinite(raw?.footprint?.heightM) ||
    raw.footprint.heightM <= 0 ||
    !isVector(raw?.footprint?.pivotM, 3)
  ) {
    issues.push('blueprint footprint must include positive sizeM/heightM and a three-axis pivotM')
  }
  if (!Array.isArray(raw?.elements) || raw.elements.length === 0) issues.push('blueprint.elements must be non-empty')
  else {
    const elementIds = new Set()
    raw.elements.forEach((element, index) => {
      if (elementIds.has(element.id)) issues.push(`blueprint.elements[${index}] duplicates id "${element.id}"`)
      elementIds.add(element.id)
      if (!catalog.moduleById[element.moduleId]) issues.push(`blueprint.elements[${index}] references missing module "${element.moduleId}"`)
    })
  }
  if (issues.length) throw new Error(`Invalid ready blueprint:\n${issues.map(issue => `- ${issue}`).join('\n')}`)

  const credits = raw.elements.reduce((total, element) => total + catalog.moduleById[element.moduleId].cost.credits, 0)
  const [width, depth] = raw.footprint.sizeM
  return {
    id: `blueprint:${raw.blueprintId}`,
    blueprintId: raw.blueprintId,
    kind: 'blueprint',
    category: 'ready',
    displayName: raw.name,
    description: raw.description,
    dimensionsM: [width, raw.footprint.heightM, depth],
    placement: { requiresPlot: true },
    structural: { supportMode: 'ground-anchor' },
    boundsOffsetM: [...raw.footprint.pivotM],
    snapPoints: [],
    cost: { credits },
    elementCount: raw.elements.length,
    blueprint: raw,
  }
}
